import { LoanRate } from "./LoanRate";
import { MortgageCategory } from "./constants";

export function getMortgageCategory (rateId: number): MortgageCategory {
    if ([LoanRate.USDA_30_YEAR].includes(rateId)) {
        return MortgageCategory.USDA;
    }
    if ([LoanRate.VA_15_YEAR, LoanRate.VA_30_YEAR].includes(rateId)) {
        return MortgageCategory.VA;
    }
    if ([LoanRate.FHA_15_YEAR, LoanRate.FHA_30_YEAR].includes(rateId)) {
        return MortgageCategory.FHA;
    }
    if ([LoanRate.FIRST_TIME_HOMEBUYER_7_6_ADJUSTABLE_RATE_MORTGAGE].includes(rateId)) {
        return MortgageCategory.FTHB_ARM;
    }
    if ([LoanRate.ADJUSTABLE_RATE_MORTGAGE_5_6, LoanRate.ADJUSTABLE_RATE_MORTGAGE_7_6, LoanRate.ADJUSTABLE_RATE_MORTGAGE_10_6,].includes(rateId)) {
        return MortgageCategory.ARM;
    }
    if ([LoanRate.FIRST_TIME_HOMEBUYER, LoanRate.FIXED_30_YEAR_SECOND_MORTGAGE_WITH_15_YEAR_BALLOON].includes(rateId)) {
        return MortgageCategory.FTHB;
    }
    if ([LoanRate.FIXED_15_YEAR_MORTGAGE_REFINANCE, LoanRate.FIXED_20_YEAR_MORTGAGE_REFINANCE, LoanRate.FIXED_30_YEAR_MORTGAGE_REFINANCE].includes(rateId)) {
        return MortgageCategory.REFINANCE;
    }
    if ([LoanRate.FIXED_15_YEAR_MORTGAGE, LoanRate.FIXED_20_YEAR_MORTGAGE, LoanRate.FIXED_30_YEAR_MORTGAGE].includes(rateId)) {
        return MortgageCategory.FIXED_MORTAGE;
    }
    if ([LoanRate.CONSTRUCTION_LOAN].includes(rateId)) {
        return MortgageCategory.CONSTRUCTION;
    }
    if ([LoanRate.JUMBO_15_YEAR, LoanRate.JUMBO_20_YEAR, LoanRate.JUMBO_30_YEAR].includes(rateId)) {
        return MortgageCategory.JUMBO;
    }
    if ([LoanRate.FIXED_15_YEAR_RATE_SECOND_MORTGAGE, LoanRate.FIXED_20_YEAR_SECOND_MORTGAGE, LoanRate.FIXED_30_YEAR_SECOND_MORTGAGE_WITH_15_YEAR_BALLOON].includes(rateId)) {
        return MortgageCategory.SECOND_MORTGAGE;
    }
    if ([LoanRate.LOT_10_YEAR_LOAN, LoanRate.LOT_20_YEAR_LOAN_WITH_7_YEAR_BALLOON].includes(rateId)) {
        return MortgageCategory.LOT;
    }
    return null;
}